<template>
    <div class="grid grid-cols-1 md:grid-cols-2 h-full bg-gray" >
        <div class="h-40 md:h-full md:min-h-screen md:max-h-full overflow-hidden relative">
            <img src="../assets/login-image.jpg" alt="Sharp - Be Original" class="hidden md:block w-full h-full object-cover object-left" loading="lazy" />
            <img src="../assets/login-image-mobile.jpg" alt="Sharp - Be Original" class="block md:hidden w-full h-full object-cover object-left" loading="lazy" />
            <div class="mobile-logo-container absolute top-8 left-8 md:hidden">
                <router-link
                        :to="{ name: 'signIn' }">
                    <img src="../assets/sharp-logo.png" alt="Sharp - Be Original" class="logo--white"/>
                </router-link>
            </div>
        </div>

        <div class="md:min-h-screen md:order-first ">
            <div class="md:w-96 page-container--home mx-auto md:mt-24 sc:mt-0 py-10 md:py-5  px-8 md:px-5">
                <div class="flex flex-col w-full h-full justify-between">
                    <div class="mb-16 hidden md:block">
                        <router-link
                                :to="{ name: 'signIn' }">
                            <img src="../assets/sharp-logo.png" alt="Sharp - Be Original"/>
                        </router-link>
                    </div>
                    <div v-if="success">
                        <div class="py-12 ">
                            <div>
                                <i class="fas fa-check-circle text-6xl text-success"></i>
                            </div>
                            <div class="text-xl mt-5">
                                Success!
                            </div>
                            <div class="style-body mt-5">
                                <p class="mb-2">
                                    The contact request has been submitted successfully.<br>
                                </p>
                                <p>
                                    We'll contact you shortly.
                                </p>
                            </div>

                            <div class="mt-8">
                                <a
                                        @click="$router.go(-1)"
                                        class="text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
                            </div>
                        </div>
                    </div>
                    <div v-else class="mb-20">
                        <h1 class="mb-5 md:mb-10">Contact Us</h1>
                        <contact-form @submit-success="onSuccess"></contact-form>
                        <div class="mt-10 style-body">
                            Other service department enquiries, <br>please call <a class="underline" href="tel:0800222444">0800 222 444</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script charset="utf-8">

import ContactForm from './form/ContactForm.vue'
import Vuex from 'vuex';

export default {

    data() {
        return {
            success: false
        }
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    components: {
        ContactForm
    },
    methods: {
        onSuccess(){
            this.success = true;
        }
    }
}
</script>
